export const STORE_WEB3_CONTEXT = 'STORE_WEB3_CONTEXT';
export const UPDATE_THOR_PRICE = 'UPDATE_THOR_PRICE';
export const UPDATE_AVAX_PRICE = 'UPDATE_AVAX_PRICE';
